export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      functionLogs: [
        {
          functionResponseUuid: 'functionResponse004',
          answeredAt: 1234567890123,
          locationNumber: "location-00004",
          nickName: "アイラ4号",
          anwser: "良いです",
          responseStatus: 3
        },
        {
          functionResponseUuid: 'functionResponse003',
          answeredAt: 1234567890123,
          locationNumber: "location-00003",
          nickName: "アイラ3号",
          anwser: "良いです",
          responseStatus: 2
        },
        {
          functionResponseUuid: 'functionResponse002',
          answeredAt: 1234567890123,
          locationNumber: "location-00002",
          nickName: "アイラ２号",
          anwser: "良いです",
          responseStatus: 1
        },
        {
          functionResponseUuid: 'functionResponse001',
          answeredAt: 1234567890123,
          locationNumber: "location-00001",
          nickName: "アイラ１号",
          anwser: "相談したい",
          responseStatus: 0
        }
      ]
    }
  }
}